import Swiper from 'swiper'

export default function () {
	document.addEventListener('DOMContentLoaded', (event) => {
		const sliderEl = document.querySelector<HTMLDivElement>('[data-news-slider]')

		if (!sliderEl) return
		new Swiper(sliderEl, {
			spaceBetween: '24px',
			slidesPerView: 1.3,
			speed: 500,
			breakpoints: {
				640: {
					slidesPerView: 2.3,
				},
				1024: {
					slidesPerView: 3.3,
				},
				1400: {
					slidesPerView: 4,
				},
			},
		})
	})
}
